import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";

const TYPE_CONFIG = {
    disruption: { icon: "⚠️", label: "Storing" },
    info: { icon: "ℹ️", label: "Informatie" },
};

const STORAGE_KEY = "dismissed_site_notices";

function getDismissedIds() {
    try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
        return [];
    }
}

function dismissIds(ids) {
    const existing = getDismissedIds();
    const merged = [...new Set([...existing, ...ids])];
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
}

export default function SiteNoticePopup({ notices = [] }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [filteredNotices, setFilteredNotices] = useState([]);

    useEffect(() => {
        const dismissed = getDismissedIds();
        const visible = notices.filter((n) => !dismissed.includes(n.id));
        setFilteredNotices(visible);
        setIsOpen(visible.length > 0);
        setCurrentIndex(0);
    }, [notices]);

    const handleClose = () => {
        dismissIds(filteredNotices.map((n) => n.id));
        setIsOpen(false);
    };

    if (!isOpen || filteredNotices.length === 0) return null;

    const notice = filteredNotices[currentIndex];
    const config = TYPE_CONFIG[notice.type] || TYPE_CONFIG.info;
    const total = filteredNotices.length;

    return (
        <Popup open={true} modal nested className="site-notice-popup">
            {(close) => (
                <div className="modal">
                    <div className="site-notice-header">
                        <div className="site-notice-type-badge">
                            <span className="site-notice-type-icon">{config.icon}</span>
                            <span className="site-notice-type-label">{config.label}</span>
                        </div>
                        <button
                            className="close"
                            onClick={() => {
                                handleClose();
                                close();
                            }}
                        >
                            &times;
                        </button>
                    </div>

                    <div className="site-notice-body">
                        <h2 className="site-notice-title">{notice.title}</h2>

                        <div className="site-notice-content" dangerouslySetInnerHTML={{ __html: notice.message }} />

                        <div className="site-notice-footer">
                            {total > 1 && (
                                <div className="site-notice-nav">
                                    <button
                                        className="site-notice-nav-btn"
                                        disabled={currentIndex === 0}
                                        onClick={() => setCurrentIndex((i) => i - 1)}
                                    >
                                        ‹
                                    </button>
                                    <span className="site-notice-counter">
                                        {currentIndex + 1}/{total}
                                    </span>
                                    <button
                                        className="site-notice-nav-btn"
                                        disabled={currentIndex === total - 1}
                                        onClick={() => setCurrentIndex((i) => i + 1)}
                                    >
                                        ›
                                    </button>
                                </div>
                            )}
                            <button
                                className="site-notice-close-btn"
                                onClick={() => {
                                    handleClose();
                                    close();
                                }}
                            >
                                Sluiten
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Popup>
    );
}
